import Calculator from './core/calculator';

const calculator = new Calculator();

export default calculator;
